import {
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Select,
} from '@chakra-ui/core';
import React from 'react';
import NumberFormat from 'react-number-format';
import { formatNumber, getBTCValue } from '../utils/Utils';

function AmountInput({
  unit,
  setUnit,
  amount,
  setAmount,
  isInvalid,
  ...props
}) {
  return (
    <InputGroup size="md" width="14em" {...props}>
      <InputLeftElement
        width="4.5rem"
        px="0"
        _hover={{ opacity: 0.75 }}
        transition="opacity 0.25s linear"
      >
        <Select
          value={unit}
          ml="1px"
          onChange={(e) => setUnit(e.target.value)}
          bg="blue.400"
          color="white"
          border="none"
          cursor="pointer"
        >
          <option value="btc">BTC</option>
          {/* <option value="usd">USD</option> */}
        </Select>
      </InputLeftElement>

      <NumberFormat
        customInput={Input}
        spellCheck="false"
        thousandSeparator={true}
        value={amount}
        decimalScale={8}
        isInvalid={isInvalid}
        // isInvalid={amount > (unit === 'btc' ? 0.02 : 2000000)}
        onValueChange={(e) => setAmount(e.floatValue)}
        pl="5rem"
        pr="3rem"
        backgroundColor="#ffffff00"
        placeholder="0.00"
      />

      <InputRightElement
        width="fit-content"
        pr="2"
        color="gray.600"
        whiteSpace="nowrap"
      >
        ${formatNumber(getBTCValue(amount || 0))} USD
      </InputRightElement>
    </InputGroup>
  );
}

export default AmountInput;
